import {TPropsWithClassName} from 'core/types';
import React, {FC, ReactNode, useEffect} from 'react';
import {useScroll} from 'core/hooks/useScroll';
import {CollapseAnimated} from 'components/CollapseAnimated';

interface IProps {
    children: ReactNode;
    isHidden?: boolean;
    onCollapsed?: (state: boolean) => void;
}
export const CollapseAnimatedOnTop: FC<TPropsWithClassName<IProps>> = ({
    children,
    isHidden = false,
    onCollapsed,
    className,
}) => {
    const isNotAtTop = useScroll(1, 0);

    useEffect(() => {
        onCollapsed?.(isNotAtTop || isHidden);
    }, [isHidden, isNotAtTop, onCollapsed]);

    return (
        <div className={className}>
            <CollapseAnimated isHidden={isNotAtTop || isHidden}>{children}</CollapseAnimated>
        </div>
    );
};
